import {
  PageCollectionConfigFontFamily,
  PageCollectionConfigRadiusClassName,
} from '@creator-suite/page-types/page-collections';

export const getFontVariable = (fontFamily: PageCollectionConfigFontFamily) => {
  switch (fontFamily) {
    case PageCollectionConfigFontFamily.INTER:
      return 'font-inter';
    case PageCollectionConfigFontFamily.ROBOTO:
      return 'font-roboto';
    case PageCollectionConfigFontFamily.AT_APOC:
      return 'font-at-apoc';
    default:
      return 'font-inter';
  }
};

export const getRoundedClassName = (
  roundedClassName?: PageCollectionConfigRadiusClassName,
) => {
  switch (roundedClassName) {
    case PageCollectionConfigRadiusClassName.ROUNDED_MD:
      return 'rounded-md';
    case PageCollectionConfigRadiusClassName.ROUNDED_LG:
      return 'rounded-lg';
    case PageCollectionConfigRadiusClassName.ROUNDED_XL:
      return 'rounded-xl';
    case PageCollectionConfigRadiusClassName.ROUNDED_2XL:
      return 'rounded-2xl';
    case PageCollectionConfigRadiusClassName.ROUNDED_FULL:
      return 'rounded-full';
    case PageCollectionConfigRadiusClassName.ROUNDED_NONE:
    default:
      return 'rounded-none';
  }
};
